// extracted by mini-css-extract-plugin
export default {"title":"delete_title__FSH7v","buttonPart":"delete_buttonPart__20gQA","buttonCancel":"delete_buttonCancel__TN+iq","buttonDelete":"delete_buttonDelete__Hr+TW"};